import React, { SyntheticEvent } from 'react'
import { Box, Tabs, Tab, Typography } from '@mui/material'

function tabProps(index: number) {
  return {
    id: `events-tab-${index}`,
    'aria-controls': `events-tabpanel-${index}`,
  }
}

interface SiteTabBarProps {
  tabValue: number
  handleTabChange: (event: SyntheticEvent, value: number) => void
}

export function SiteTabBar({ tabValue, handleTabChange }: SiteTabBarProps) {
  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
      <Tabs value={tabValue} onChange={handleTabChange} aria-label="Site tabs">
        <Tab label="Info" {...tabProps(0)} />
        <Tab label="Events Data" {...tabProps(1)} />
        <Tab label="Actions" {...tabProps(2)} />
      </Tabs>
    </Box>
  )
}

interface SiteTabPanelProps {
  value: number
  index: number
  children?: React.ReactNode
}

export function SiteTabPanel({ children, value, index }: SiteTabPanelProps) {
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`events-tabpanel-${index}`}
      aria-labelledby={`events-tab-${index}`}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </Typography>
  )
}
